// import './css/style.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import store from './store';
import {routes, loginRoutes, supportRoutes, saleRoutes, accountantRoutes, supportLeaderRoutes} from './layout/Routes'
import MainLayout from './layout/Main'
import {NotFound} from './layout/NotFound'
import {connect} from 'react-redux'
import BlockUI from './component/BlockUI'
import axios from 'axios'

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    window.api_url = "http://localhost:4000";
} else {
    window.api_url = "https://api3.tadu.cloud";
}

// Request interceptor for API calls
axios.interceptors.request.use(
    // // Set Header Authorization cho những lúc gọi api thông qua axios.
    async(config) => {
        if(localStorage.getItem('auth_token')) {
            config.headers = {
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
            };
        }

        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

axios.defaults.withCredentials = true

function LoginLayout() {
    return(
        <Switch>
            {loginRoutes.map((route, index) => (
                <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
            ))}
            <Route component={NotFound} />
        </Switch>
    )
}

class App extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.checkTokenAsync();
        this.props.loadUserAsync();
    }

    render() {
        const {isLoading, login, userProfile} = this.props;
        return(
            <React.Fragment>
                {isLoading && <BlockUI/>}
                {!login && !isLoading && <LoginLayout/>}
                {login && !isLoading && userProfile && <MainLayout>
                    {userProfile && <Switch>
                        {userProfile.role == "MASTER" && routes.map((route, index) => (
                            <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
                        ))}
                        {userProfile.role == "IT" && supportRoutes.map((route, index) => (
                            <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
                        ))}
                        {userProfile.role == "IT_LEADER" && supportLeaderRoutes.map((route, index) => (
                            <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
                        ))}
                        {userProfile.role == "SALE" && saleRoutes.map((route, index) => (
                            <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
                        ))}
                        {userProfile.role == "ACCOUNTING" && accountantRoutes.map((route, index) => (
                           <Route key={index} exact={route.exact} path={route.path} render={route.render}/>
                        ))}
                        <Route component={NotFound} />
                    </Switch>}
                </MainLayout>}
            </React.Fragment>
        )
    }
}

const mapState = state => ({
    login: state.app.login,
    isLoading: state.app.isLoading,
    userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({
    checkTokenAsync: () => dispatch.app.checkTokenAsync(),
    loadUserAsync: () => dispatch.userProfile.loadUserAsync()
});

const AppContainer = connect(mapState, mapDispatch)(App);

let domContainer = document.getElementById('root');

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <AppContainer/>
        </Provider>
    </Router>, domContainer
);